import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useZendeskChat } from '@libs/hooks';
import { ChatIcon } from '../assets';
import Typography from '../typography/Typography';
import { TransparentButton } from '../transparent-button/TransparentButton';
import { IconWrapper, NotificationAlert, WorkHoursBadge } from './styles';
const HeaderChat = ({ className, chatButtonId, chatIconId, workHours, backgroundColor, }) => {
    const { colors } = useTheme();
    const { toggleChat, unreadCount } = useZendeskChat({
        fromMobileApp: window.isFromMobileApp,
        windowZe: window.zE,
    });
    return (_jsx(TransparentButton, { onClick: toggleChat, className: className, id: chatButtonId, children: _jsxs(IconWrapper, { color: backgroundColor || colors.surface.interactiveDefault, className: "icon-wrapper", children: [unreadCount <= 0 && (_jsx(WorkHoursBadge, { children: _jsx(Typography, { color: colors.interactive.brandColor, type: "caption", fontFamily: "primaryBold", children: workHours }) })), unreadCount > 0 && (_jsx(NotificationAlert, { children: _jsx(Typography, { type: "caption", fontFamily: "primaryBold", color: colors.text.interactive, children: unreadCount }) })), _jsx(ChatIcon, { id: chatIconId })] }) }));
};
export default HeaderChat;
//# sourceMappingURL=HeaderChat.js.map